import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../../../../../common/constants/constants';
import { IconFolder, IconCaseHome } from '../../../../../../common/images';
import { Case } from '../../../../../../common/models/common-types';
import { i18n } from '../../../../../../common/i18n/i18n';

interface CeaseBreadcrumbsItemProps {
    caseItem: Case;
    onCaseClickAction: (id: string) => void;
    rootCase?: boolean;
}

const CeaseBreadcrumbsItem: FC<CeaseBreadcrumbsItemProps> = ({ caseItem, onCaseClickAction, rootCase }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
        }}
        onClick={() => onCaseClickAction(caseItem.id)}
    >
        {rootCase ? (
            <IconCaseHome
                className="fill-md"
                style={{
                    marginRight: '8px',
                    width: '16px',
                    height: '12px',
                }}
            />
        ) : (
            <IconFolder
                className="fill-md"
                style={{
                    marginRight: '8px',
                    width: '16px',
                    height: '12px',
                }}
            />
        )}

        <Typography
            className="color-mh"
            sx={{
                'fontSize': '16px',
                'fontWeight': 500,
                '&:hover': {
                    borderBottom: `1px solid ${COLORS.BRAND_DARK}`,
                },
            }}
        >
            {rootCase ? i18n.translate('Searches') : caseItem.name}
        </Typography>
    </Box>
);

export default CeaseBreadcrumbsItem;
